module.exports = __webpack_public_path__ + "images/emoji/registered.fab1873fe6ec0b659def.png";